import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BackgroundIndustrial from './background-industrial';
import BackgroundEntertainment from './background-entertainment';
import BackgroundContainers from './background-containers';
import BackgroundPassengers from './background-passengers';
import { BackgroundBase } from '../stateless/background-base';
import BackgroundRoads from './background-roads';
import { BackgroundFleetParade } from '../stateless/background-fleet-parade';
import { CSSTransitionGroup } from 'react-transition-group';

/**
 * @class App
 *
 * @description
 * Class for the main app.
 *
 * @example
 * <App />
 */
@connect(
	state => ({
		playersSaveSate: state.results.saveState ? state.results.saveState.players : null,
		step: state.step,
		fleetParadeActive: state.fleetParade.fleetParadeActive,
		appView: state.appView,
	})
)
export default class Background extends Component {

	static PropTypes = {
		background: PropTypes.object,
		playersSaveSate: PropTypes.object
	};

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {Component} component
	 */
	render () {
		const { playersSaveSate, step, fleetParadeActive } = this.props;

		return (this.props.appView === 'game' && playersSaveSate) ? (
			<div className="background-container">
				<div>
					<BackgroundBase/>
					<BackgroundRoads progress={step.activeIndex}/>
					<BackgroundEntertainment progress={playersSaveSate['player-1'].resources} assets={playersSaveSate['player-1'].rewards} />
					<BackgroundPassengers progress={playersSaveSate['player-2'].resources}/>
					<BackgroundContainers progress={playersSaveSate['player-3'].resources} assets={playersSaveSate['player-3'].rewards} />
					<BackgroundIndustrial progress={playersSaveSate['player-4'].resources}/>
					<CSSTransitionGroup
						className="fade"
						transitionName="fade"
						transitionEnterTimeout={800}
						transitionLeaveTimeout={800}
					>
						{fleetParadeActive && <BackgroundFleetParade/>}
					</CSSTransitionGroup>
				</div>
			</div>
		) : null;
	}
}
